(function(){"use strict";
/* CSS: sticky bar + reset nuclear de quick-add (pseudo-elementos y custom props) */
if(!document.getElementById("pv-sticky-css")){var st=document.createElement("style");st.id="pv-sticky-css";st.textContent=".pv-sticky-bar{position:fixed;bottom:0;left:0;right:0;z-index:9999;background:#fff;border-top:2px solid #f0ebe8;box-shadow:0 -3px 16px rgba(0,0,0,.14);padding:10px 16px;display:flex;align-items:center;gap:10px;transform:translateY(110%);transition:transform .28s cubic-bezier(.4,0,.2,1);will-change:transform}.pv-sticky-bar.pv-sticky-visible{transform:translateY(0)}.pv-sticky-bar.pv-sticky-hidden{display:none!important}.pv-sticky-thumb{width:48px;height:48px;object-fit:cover;border-radius:8px;flex-shrink:0}.pv-sticky-info{flex:1;min-width:0;display:flex;flex-direction:column}.pv-sticky-name{font-size:12px;font-weight:700;color:#111;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.pv-sticky-price,.pv-sticky-total{font-size:15px;font-weight:800;color:#1E8449;line-height:1.2}.pv-sticky-btn{flex-shrink:0;background:linear-gradient(135deg,#1E8449 0%,#145A32 100%);color:#fff;border:none;border-radius:6px;padding:11px 18px;font-size:12px;font-weight:800;cursor:pointer;letter-spacing:.5px;text-transform:uppercase;white-space:nowrap;box-shadow:0 2px 10px rgba(30,132,73,.4)}.pv-sticky-btn:active{opacity:.88}@media(min-width:750px){.pv-sticky-bar{padding:12px 40px;max-width:900px;left:50%;right:auto;transform:translateX(-50%) translateY(110%);border-radius:16px 16px 0 0;width:100%}.pv-sticky-bar.pv-sticky-visible{transform:translateX(-50%) translateY(0)}}" +
/* ===== NUCLEAR: pseudo-elementos + custom props de Dawn ===== */
".pv-rappi-card .quick-add *::before,.pv-rappi-card .quick-add *::after{content:none!important;display:none!important;border:none!important;background:none!important;box-shadow:none!important;outline:none!important}" +
".pv-rappi-card .quick-add,.pv-rappi-card .quick-add *:not(.quick-add__submit):not(.pv-qa-txt){border:0!important;border-color:transparent!important;border-width:0!important;border-style:none!important;border-radius:0!important;outline:none!important;box-shadow:none!important;background:transparent!important;background-color:transparent!important;background-image:none!important;--color-button:transparent;--inputs-border-width:0;--inputs-border-color:transparent;--variant-pills-border-width:0}";
document.head.appendChild(st)}

/* ===== STICKY BAR EN PRODUCT PAGE ===== */
function pvStickyInit(){
  if(!document.body.classList.contains("pv-tpl-product")&&!document.body.classList.contains("template-product"))return;
  if(document.querySelector(".pv-sticky-bar"))return;
  var ic=document.querySelector(".product__info-container");
  if(!ic)return;
  var submitBtn=null;
  ic.querySelectorAll(".product-form__submit").forEach(function(b){
    if(b.id&&b.id.indexOf("ProductSubmitButton")===0)submitBtn=b;
  });
  if(!submitBtn)return;
  var titleDiv=ic.querySelector(".product__title");
  var titleText="";
  if(titleDiv){var h1=titleDiv.querySelector("h1");titleText=(h1||titleDiv).textContent.trim().split("\n")[0].trim()}
  var priceEl=ic.querySelector(".price-item--regular,.price-item");
  var thumbEl=document.querySelector(".product__media-item img,.product__media img");
  var thumbSrc=thumbEl?(thumbEl.currentSrc||thumbEl.src):"";
  var thumbHtml=thumbSrc?'<img class="pv-sticky-thumb" src="'+thumbSrc+'" alt="" loading="lazy" width="48" height="48">':"";
  var bar=document.createElement("div");
  bar.className="pv-sticky-bar";
  var priceText=(window.PV_TOTAL)||(priceEl?priceEl.textContent.trim():"");
  bar.innerHTML=thumbHtml+'<div class="pv-sticky-info"><span class="pv-sticky-name">'+titleText+'</span><span class="pv-sticky-price pv-sticky-total">'+priceText+'</span></div><button class="pv-sticky-btn" type="button">🛒 AGREGAR AL PEDIDO</button>';
  document.body.appendChild(bar);
  bar.querySelector(".pv-sticky-btn").addEventListener("click",function(){submitBtn.click()});
  try{if(typeof window.pvUpdateComboTotal==="function")window.pvUpdateComboTotal()}catch(e){}
  var obs=new IntersectionObserver(function(en){en.forEach(function(e){var show=!e.isIntersecting;bar.classList.toggle("pv-sticky-visible",show);document.body.classList.toggle("pv-sticky-active",show)})},{threshold:0});
  obs.observe(submitBtn);
  var cd=document.querySelector("cart-drawer");
  if(cd){new MutationObserver(function(){var open=cd.classList.contains("active")||!!(cd.querySelector("#CartDrawer")||{classList:{contains:function(){return false}}}).classList.contains("active");bar.classList.toggle("pv-sticky-hidden",open)}).observe(cd,{attributes:true,subtree:true,attributeFilter:["class","open"]})}
}

/* ===== QUICK-ADD: botón píldora verde (v6 — nuclear) ===== */
var BTN_P=[
  ["display","inline-flex"],["align-items","center"],["justify-content","center"],
  ["width","auto"],["min-width","0"],["max-width","none"],
  ["height","auto"],["min-height","0"],
  ["border-radius","99px"],["padding","6px 14px"],
  ["background","linear-gradient(135deg,#1E8449 0%,#145A32 100%)"],
  ["color","#fff"],["border","none"],["border-color","transparent"],
  ["border-width","0"],["border-style","none"],["outline","none"],
  ["box-shadow","0 2px 8px rgba(30,132,73,.4)"],
  ["font-size","10px"],["font-weight","800"],
  ["letter-spacing",".5px"],["text-transform","uppercase"],
  ["line-height","1.5"],["cursor","pointer"],
  ["position","static"],["transform","none"],["white-space","nowrap"],
  ["overflow","visible"],["clip-path","none"],["flex-shrink","0"],
];
var TXT_P=[
  ["display","inline"],["color","#fff"],["font-size","10px"],
  ["font-weight","800"],["letter-spacing",".5px"],["text-transform","uppercase"],
  ["white-space","nowrap"],["position","static"],
  ["width","auto"],["height","auto"],["overflow","visible"],
];

function pvResetEl(el){
  /* Propiedades estándar */
  el.style.setProperty("border","none","important");
  el.style.setProperty("border-color","transparent","important");
  el.style.setProperty("border-width","0","important");
  el.style.setProperty("border-style","none","important");
  el.style.setProperty("border-radius","0","important");
  el.style.setProperty("background","transparent","important");
  el.style.setProperty("background-color","transparent","important");
  el.style.setProperty("background-image","none","important");
  el.style.setProperty("box-shadow","none","important");
  el.style.setProperty("padding","0","important");
  el.style.setProperty("outline","none","important");
  el.style.setProperty("outline-width","0","important");
  el.style.setProperty("clip-path","none","important");
  /* CSS custom properties de Dawn que generan el borde naranja */
  el.style.setProperty("--color-button","transparent");
  el.style.setProperty("--inputs-border-width","0");
  el.style.setProperty("--inputs-border-color","transparent");
  el.style.setProperty("--variant-pills-border-width","0");
}

function pvQuickAddFix(){
  document.querySelectorAll(".pv-rappi-card").forEach(function(card){
    /* Reset nuclear: TODOS los elementos dentro de .quick-add */
    var qa=card.querySelector(".quick-add");
    if(qa){
      pvResetEl(qa);
      qa.style.setProperty("display","block","important");
      qa.style.setProperty("text-align","center","important");
      qa.style.setProperty("width","100%","important");

      qa.querySelectorAll("*").forEach(function(el){
        if(!el.classList.contains("quick-add__submit")&&!el.classList.contains("pv-qa-txt")){
          pvResetEl(el);
          el.style.setProperty("display","block","important");
          el.style.setProperty("text-align","center","important");
          el.style.setProperty("width","100%","important");
        }
      });
    }

    var btn=card.querySelector(".quick-add__submit");
    if(!btn)return;

    /* Botón: estilos inline !important — imbatibles */
    BTN_P.forEach(function(p){btn.style.setProperty(p[0],p[1],"important");});

    /* Ocultar TODOS los descendientes del botón */
    btn.querySelectorAll("*").forEach(function(el){
      if(!el.classList.contains("pv-qa-txt")){
        el.style.setProperty("display","none","important");
      }
    });

    /* Inyectar/actualizar span de texto */
    var sp=btn.querySelector(".pv-qa-txt");
    if(!sp){sp=document.createElement("span");sp.className="pv-qa-txt";btn.appendChild(sp);}
    if(sp.textContent!=="Agregar r\xe1pido")sp.textContent="Agregar r\xe1pido";
    TXT_P.forEach(function(p){sp.style.setProperty(p[0],p[1],"important");});
  });
}

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",function(){
    setTimeout(pvStickyInit,800);
    setTimeout(pvQuickAddFix,100);
    setInterval(pvQuickAddFix,500);
  });
}else{
  setTimeout(pvStickyInit,800);
  setTimeout(pvQuickAddFix,100);
  setInterval(pvQuickAddFix,500);
}
document.addEventListener("shopify:section:load",function(){setTimeout(pvQuickAddFix,300)});
})();
